
import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import {
  fertilizerElements,
  FertilizerTable,
} from '../../../advice/models/fertilization-result.model';
@Component({
  selector: 'app-fertilization-table',
  templateUrl: './fertilization-table.component.html',
  styleUrls: ['./fertilization-table.component.scss'],
  standalone: false,
})
export class FertilizationTableComponent implements OnInit, AfterContentChecked, OnDestroy {
  private readonly cdref = inject(ChangeDetectorRef);

  @Output() headerClick = new EventEmitter<Event>();
  @Output() isDoneRendering = new EventEmitter<boolean>();
  @Input() showHeaders = false;
  @Input() tableReportData$: BehaviorSubject<FertilizerTable[]>;
  @Input() set isCollapsable(value: boolean) {
    this.isCollapsable$.next(value);
  }

  readonly itemsToRenderAtOnce = 5;
  readonly intervalToRenderItems = 10;

  reportData: FertilizerTable[] = [];
  isCollapsable$ = new BehaviorSubject<boolean>(true);
  columnsWith2Decimals = ['mn', 'fe', 'b'];
  elements = fertilizerElements.map((element) => ({
    element,
    numberOfDecimals: this.columnsWith2Decimals.indexOf(element) !== -1 ? 2 : 0,
  }));
  displayedColumns = ['kg/ha', 'displayDosage', ...fertilizerElements];
  renderedItemsSoFar = new BehaviorSubject<number>(0);

  private subscriptions = new Subscription();

  ngOnInit() {
    this.subscriptions.add(
      this.tableReportData$.subscribe((data) => {
        this.reportData = [];
        data.forEach((x) => {
          this.reportData.push(x);
        });
        this.cdref.detectChanges();
      }),
    );
    this.subscriptions.add(
      this.renderedItemsSoFar.subscribe((itemsRendered) =>
        this.isDoneRendering.emit(itemsRendered >= this.reportData.length),
      ),
    );
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  canShowItemsRenderingNotification() {
    return (
      this.reportData.length > this.itemsToRenderAtOnce &&
      this.renderedItemsSoFar.value < this.reportData.length
    );
  }

  trackByFn(index: number) {
    return index;
  }
}
